"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_native_1 = require("react-native");
const colors_1 = __importDefault(require("../../styles/colors"));
const styles = react_native_1.StyleSheet.create({
    activeLoansContainer: {
        marginTop: 15,
        marginBottom: 8,
    },
    subtileMargin: {
        marginTop: 15,
        marginBottom: 8,
    },
    tab: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
        borderBottomWidth: 2,
    },
    tabActiveContentStyle: {
        borderBottomColor: colors_1.default.COLOR_PRIMARY,
    },
    tabInactiveContentStyle: {
        borderBottomColor: colors_1.default.COLOR_GRAY,
    },
    boxContainer: {
        flexDirection: 'column',
        marginVertical: 10,
        paddingVertical: 10,
        width: '100%',
        borderRadius: 16,
        paddingHorizontal: 5,
        backgroundColor: colors_1.default.COLOR_WHITE,
        maxWidth: 750,
    },
});
exports.default = styles;
